















import { Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class ConfirmDialog extends Vue {
  public dialog = false;
  public okCallBack: ((arg: any) => void)|null = null;
  public arg: any = null;
  public title = '';

  public async startDialog(title: string, callBackFnc: (arg: any) => void, arg: any) {
    this.title = title;
    this.okCallBack = callBackFnc;
    this.arg = arg;
    this.dialog = true;
  }

  public async handleOk() {
    if (this.okCallBack) {
      await this.okCallBack(this.arg);
    }
  }
}
